import axios from "axios";
import {
  API_MAX_CONTENT_LENGTH,
  API_TIMEOUT_LIMIT,
  LANGUAGE_CODE,
} from "../../helpers/constants";
import { store } from "../../redux/store";
import { getValueOrBlank, validateApiParamValue } from "../../helpers/utils";

const baseURL = process.env.REACT_APP_API_BASE_URL_NEW;

const apiInstance = axios.create({
  baseURL: `${baseURL}`,
  timeout: API_TIMEOUT_LIMIT,
  maxContentLength: API_MAX_CONTENT_LENGTH,
});

// Get preferred language from Redux store
const getPreferredLanguage = () => {
  return getValueOrBlank(store.getState()?.app?.appState?.preferredLanguage);
};

apiInstance.interceptors.request.use(
  (request) => {
    const token = sessionStorage.getItem("AccessToken");

    // Set the Accept-Language header
    request.headers["accept-language"] =
      validateApiParamValue(getPreferredLanguage()) || LANGUAGE_CODE.EN_US;

    if (!!token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default apiInstance;
